// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "10470e797b02";
export const BUILD_VERSION_NUMBER = 40;
